import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.abyss-card-root': {
    backgroundColor: 'white',
  },
  '.abyss-grid-col:last-child': {
    borderRight: 'none',
  },
  '.abyss-grid-col .abyss-grid-col': {
    borderRight: '1px solid var(--abyss-colors-gray4)',
    paddingLeft: 'var(--abyss-space-xl)',
    paddingRight: 'var(--abyss-space-xl)',
  },
  marginBottom: 'var(--abyss-space-xl)',
  marginTop: 'var(--abyss-space-lg)',
});
